import mapboxgl from 'mapbox-gl';

export function mapbox() {
    mapboxgl.accessToken = 'pk.eyJ1IjoibWFkbWFrIiwiYSI6ImNrYWIxaXBzbTB6MnkydGw1dWplcWo5MDYifQ.UcPQCRmxp2H994Xv9vrpyQ';

    let maps = document.querySelectorAll('[data-mapbox]');

    maps.forEach(mapElement => {
        let center = mapElement.getAttribute('data-center').split(',');
        let boundsStart = mapElement.getAttribute('data-boundsStart').split(',');
        let boundsEnd = mapElement.getAttribute('data-boundsEnd').split(',');
        let start = mapElement.getAttribute('data-start').split(','); // start route point
        let coordsEnd = mapElement.getAttribute('data-coordsEnd').split(','); // end route point
        let zoom = mapElement.getAttribute('data-zoom');

        const map = new mapboxgl.Map({
            container: mapElement, // container ID
            style: 'mapbox://styles/madmak/clywnxxuu007701pc2vmt6lf6', // style URL
            center: center, // starting position [lng, lat]
            zoom: zoom, // starting zoom
        });

        const bounds = [
            boundsStart,
            boundsEnd
        ];
        map.setMaxBounds(bounds);


        // create a function to make a directions request
        async function getRoute(end) {
            // make a directions request using driving profile
            const query = await fetch(
                `https://api.mapbox.com/directions/v5/mapbox/driving/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
                { method: 'GET' }
            );
            const json = await query.json();
            const data = json.routes[0];
            const route = data.geometry.coordinates;
            const geojson = {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: route
                }
            };
            // if the route already exists on the map, we'll reset it using setData
            if (map.getSource('route')) {
                map.getSource('route').setData(geojson);
            }
            // otherwise, we'll make a new request
            else {
                map.addLayer({
                    id: 'route',
                    type: 'line',
                    source: {
                        type: 'geojson',
                        data: geojson,
                        "lineMetrics": true
                    },
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        // 'line-color': '#3887be',
                        'line-gradient': [
                            'interpolate',
                            ['linear'],
                            ['line-progress'],
                            0, '#3B45B8',
                            0.5, '#74CFF9',
                            1, '#8649E7'
                        ],
                        'line-width': 6,
                        'line-opacity': 1,
                    }
                });
            }
            // add turn instructions here at the end
        }


        map.on('load', () => {
            // make an initial directions request that
            // starts and ends at the same location
            getRoute(start);

            // Add starting point to the map
            map.addLayer({
                id: 'point',
                type: 'circle',
                source: {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: [
                            {
                                type: 'Feature',
                                properties: {},
                                geometry: {
                                    type: 'Point',
                                    coordinates: start
                                }
                            }
                        ]
                    }
                },
                paint: {
                    'circle-radius': 10,
                    'circle-color': '#3B45B8',
                    'circle-stroke-color': '#fff',
                    'circle-stroke-opacity': 0.1,
                    'circle-stroke-width': 4
                }
            });


            const end = {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'Point',
                            coordinates: coordsEnd
                        }
                    }
                ]
            };
            if (map.getLayer('end')) {
                map.getSource('end').setData(end);
            } else {
                map.addLayer({
                    id: 'end',
                    type: 'circle',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: [
                                {
                                    type: 'Feature',
                                    properties: {},
                                    geometry: {
                                        type: 'Point',
                                        coordinates: coordsEnd
                                    }
                                }
                            ]
                        }
                    },
                    paint: {
                        'circle-radius': 10,
                        'circle-color': '#8649E7',
                        'circle-stroke-color': '#fff',
                        'circle-stroke-opacity': 0.1,
                        'circle-stroke-width': 4
                    }
                });
            }
            getRoute(coordsEnd);

        });

        let tab = mapElement.closest('[data-tabpanel]');
        let tabID = tab.getAttribute('data-tabpanel');
        let tabBtn = document.querySelector(`[data-tabBtn=${tabID}]`);

        function updateMap() {
            map.resize();
        }

        if (tabBtn) {
            tabBtn.addEventListener('click', updateMap);
        }

    }) // End foreach

}
